module.exports = __webpack_public_path__ + "static/img/hr-logo.1ad2807.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/hr-logo.png
// module id = dHrW
// module chunks = 12